
import { supabase } from "@/integrations/supabase/client";
import { QueryResult } from "../types";

/**
 * Queries related to recent contracts
 */
export const recentContractsQueries = {
  // Get recent contracts
  getRecentContracts: async (year?: number): Promise<QueryResult> => {
    try {
      const currentYear = year || new Date().getFullYear();
      const startOfYear = new Date(currentYear, 0, 1).toISOString();
      const endOfYear = new Date(currentYear, 11, 31, 23, 59, 59).toISOString();
      
      const { data: recentContracts, error } = await supabase
        .from('contracts')
        .select(`
          id, 
          supplier_name, 
          signed_date, 
          type, 
          expected_cost, 
          created_at, 
          expiry_date, 
          contract_type_id, 
          contract_types(name, auto_renews),
          currency_id,
          importance,
          user_id
        `)
        .gte('created_at', startOfYear)
        .lte('created_at', endOfYear)
        .order('created_at', { ascending: false })
        .limit(5);
      
      if (error) throw error;
      
      return {
        data: { recentContracts },
        error: null
      };
    } catch (error) {
      console.error("Error fetching recent contracts:", error);
      return {
        data: { recentContracts: [] },
        error
      };
    }
  }
};
